import React from 'react';

import { useMutation } from '@tanstack/react-query';
import * as Yup from 'yup';

import Modal from '../../../../../../Modal';
import CrudForm from '../../../../../../Form/CrudForm';

import BankStatementService from '../../../../../../../services/BankStatementService';
import BankStatementTransactionService from '../../../../../../../services/BankStatementTransactionService';
import { useUiStore } from '../../../../../../../store';

const fields = [
  {
    label: 'Date',
    name: 'date',
    type: 'date',
  },
  {
    label: 'Description',
    name: 'description',
    type: 'text',
    validation: Yup.string().required('This field is required'),
  },
  {
    label: 'Deposit Amount',
    name: 'depositAmount',
    type: 'currency',
  },
  {
    label: 'Deduction Amount',
    name: 'deductionAmount',
    type: 'currency',
  },
  {
    label: 'Excluded',
    name: 'isExcluded',
    type: 'checkbox',
  },
  {
    label: 'Exclusion Reason',
    name: 'exclusionReason',
    type: 'text',
  },
];

export default function TransactionAddOrEditModal({
  isVisible,
  hideModal,
  transaction,
  refetch,
  bankStatementId,
}) {
  const isEdit = !!transaction;

  const notifySuccess = useUiStore((state) => state.notifySuccess);
  const notifyApiError = useUiStore((state) => state.notifyApiError);

  const { mutate: createTransaction, isPending: isUpdating } = useMutation({
    mutationFn: (formValues) =>
      BankStatementService.createBankStatementTransaction({
        formValues,
        id: bankStatementId,
      }),
    onSuccess: () => {
      refetch();
      notifySuccess('Transaction created successfully');
      hideModal();
    },
    onError: (error) => {
      console.log(error);
      notifyApiError(error);
    },
  });

  const { mutate: updateTransaction, isPending: isCreating } = useMutation({
    mutationFn: (formValues) =>
      BankStatementTransactionService.updateBankStatementTransaction({
        formValues,
        id: transaction.id,
      }),
    onSuccess: () => {
      refetch();
      notifySuccess('Transaction updated successfully');
      hideModal();
    },
    onError: (error) => {
      console.log(error);
      notifyApiError(error);
    },
  });

  const isPending = isCreating || isUpdating;

  return (
    <Modal
      zIndex={1000}
      isVisible={isVisible}
      hideModal={hideModal}
      title={isEdit ? 'Edit Transaction' : 'Add Transaction'}
    >
      <div className="pt-4 fle w-full">
        <CrudForm
          fields={fields}
          data={transaction}
          submitButtonLabel="Submit"
          updateHandler={updateTransaction}
          createHandler={createTransaction}
          isPending={isPending}
        />
      </div>
    </Modal>
  );
}
